module.exports = __webpack_public_path__ + "static/media/V75.7da2b7a1.png";